import {
  gmap as gmapStyle,
  storeIcon,
  headquarterIcon,
  showroomIcon,
  mainStoreIcon
} from './styles'
import { countries } from './mapData'
import Map from './map'
import { getDistance } from 'geolib'

const config = {
  apiKey: 'AIzaSyAljFuK4yGoupMoggOLf4VUvDqPosxwJYY',
  position: {
    timeout: 1000,
    maximumAge: 0
  },
  map: {
    selector: '#map',
    maxStoreDistance: 60000,
    initialPosition: {
      lat: 45.4654219,
      lng: 9.1859243
    },
    defaultCountry: 'IT',
    defaultLocality: 'Milan',
    setup: google => ({
      zoom: 9,
      maxZoom: 11,
      styles: gmapStyle,
      disableDefaultUI: true,
      scrollwheel: false,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP
      },
      fullscreenControl: false,
      backgroundColor: '#000'
    }),
    icons: {
      store: storeIcon,
      headquarter: headquarterIcon,
      showroom: showroomIcon,
      mainStore: mainStoreIcon
    }
  },
  search: {
    componentRestrictions: { country: 'it' },
    types: ['(cities)']
  }
}

const map = new Map(config)
const sources = {
  showrooms: window.rm_source_data.showrooms,
  agents: window.rm_source_data.agents
}
const translate = window.locatorTranslations

const countryInput = $('#country')
const cityInput = $('#city')
const searchButton = $('#search')

const locationsListFilters = $('#data_list .filters > div')

function filterLocationsLink (e) {
  const btn = $(this)
  const dataList = $('#data_list')
  const template = dataList.find('.filter-result').first()
  let data = sources[btn.data('source')]

  // Show as select for mobile devices
  // If there are hidden buttons but self is visible show all
  // If all buttons are visible the fake select is open, so we will close it and filter the selected one
  if (
    locationsListFilters.parent().find('.hidden').length &&
    !btn.hasClass('hidden')
  ) {
    locationsListFilters.removeClass('hidden')
    locationsListFilters
      .parent()
      .find('svg')
      .attr('transform', 'rotate(180)')
    return
  } else {
    locationsListFilters.addClass('hidden text-black')
    btn.removeClass('hidden text-black')
    locationsListFilters
      .parent()
      .find('svg')
      .removeAttr('transform')
  }

  if (btn.data('type')) { data = data.filter(item => item.type === btn.data('type')) }

  const countryFilter = btn.data('country')

  if (countryFilter) {
    data = data.filter(item => {
      if (countryFilter && /^\!/.test(countryFilter)) { return item.country !== countryFilter.replace(/^\!/, '') } else return item.country === countryFilter.replace(/^\!/, '')
    })
  }

  dataList.find('#filtered').empty()

  for (const item of data) {
    const dom = template.clone()

    dom.find('[data-content]').each(function () {
      const key = $(this).data('content')
      const content = item[key]

      $(this).html((content || '').replace(/\n/g, '<br/>'))
    })

    if (item.city) dom.find('.title').text(item.city)
    else if (item.region) dom.find('.title').text(item.region)
    else if (item.country) {
      dom.find('.title').text(item.country_name)
      dom.find('.name').text(item.name)
    } else {
      dom.find('.title').text(item.name)
      dom.find('.name').hide()
    }

    if (item.directions) {
      dom
        .find('.directions')
        .html(`<a target='_blank' href='${item.directions}'>${translate.directions}</a>`)
    }

    if (item.type === 'showroom') {
      dom
        .find('.view_more')
        .html(`<a href='${item.href}'>${translate.viewMore}</a>`)
    }

    dom.appendTo(dataList.find('#filtered')).show()
  }
}

function getCountryNameByCode (countryCode) {
  const match = countries.find(c => c.code === countryCode)
  if (!match) return ''

  return match.name
}

function buildCountrySelect (selector, countries) {
  const select = document.querySelector(selector)
  const frag = document.createDocumentFragment()

  for (const country of countries) {
    if (
      sources.showrooms.find(showroom => showroom.country === country.code) ===
      undefined
    ) { continue } // Show only countries with markers available
    const option = document.createElement('option')
    option.value = country.code
    option.innerHTML = country.name
    frag.appendChild(option)
  }

  select.appendChild(frag)
}

/**
 * Search for location and populate map with nearby stores
 * @param {String} country
 * @param {String} city
 */
async function searchApplyLocation (country, city) {
  $('#error').text('')
  try {
    const position = await map.getAddressCoordinates(getCountryNameByCode(country), city)
    const isMainCountry = country === config.map.defaultCountry

    let markers = getCountryMarkers(sources.showrooms, country)
    markers = isMainCountry ? getNearMarkers(markers, position) : markers

    // If no markers found, increase the search radius
    if (markers.length === 0) {
      const originalDistance = config.map.maxStoreDistance
      config.map.maxStoreDistance = 220000 // increasing the search radius to 200km in case 0 result
      markers = isMainCountry ? getNearMarkers(getCountryMarkers(sources.showrooms, country), position) : markers
      config.map.maxStoreDistance = originalDistance // Reset to original distance
    }

    

    markers = orderMarkers(markers, isMainCountry, position)

    map.buildMapMarkers(markers)
    showSearchResults(markers, isMainCountry)

    return position
  } catch (e) {
    $('#error').text('Cannot find location')
  }
}

function showSearchResults (markers, isMainCountry) {
  const template = $('.search_results .result').first()

  $('.results_list').empty()

  for (const marker of markers) {
    const dom = template.clone()
    // const markerIcon = config.map.icons[marker.type]

    var markerIcon = config.map.icons[marker.type]
    if( marker.main_type == 'Y' ){
      var markerIcon = config.map.icons['mainStore']
    }

    dom
      .find('.store_img svg path')
      .attr('d', markerIcon.path)
      .attr('stroke', markerIcon.strokeColor)
      .attr('fill', markerIcon.fillColor)
      .attr('stroke-width', markerIcon.strokeWeight)
      .attr('transform', `scale(${markerIcon.scale})`)

    dom.find('[data-content]').each(function () {
      const content = marker[$(this).data('content')]
      $(this).html((content || '').replace(/\n/g, '<br/>'))
    })

    if (marker.type === 'showroom') {
      dom
        .find('.view_more')
        .html(`<a href='${marker.href}'>${translate.bookAnAppointment}</a>`)
      dom.find('.title').text(marker.name)
    } else if (!isMainCountry) {
      dom.find('.title').text(marker.city)
      dom.find('.name').text(marker.name)
    } else {
      dom.find('.title').text(marker.name)
    }

    if (marker.directions) {
      dom
        .find('.directions')
        .html(`<a target='_blank' href='${marker.directions}'>${translate.directions}</a>`)
    }

    dom.appendTo('.results_list').show()
  }
}

function getCountryMarkers (markers, countryCode) {
  return markers.filter(marker => marker.country === countryCode)
}

function getNearMarkers (markers, centerPosition) {
  return markers.filter(
    marker =>
      getDistance(centerPosition, marker.coordinates) <=
      config.map.maxStoreDistance
  )
}

function orderMarkers (markers, isMainCountry, centerPosition = false) {
  const whiteLabel = 'showroom'

  if (!centerPosition) return markers

  markers = markers.sort((a, b) => {
    const dista = getDistance(centerPosition, a.coordinates)
    const distb = getDistance(centerPosition, b.coordinates)

    if (a.type === whiteLabel && b.type !== whiteLabel) return -1
    if (a.is_flagship) return -1
    if (b.is_flagship) return 1

    if (isMainCountry) {
      return dista < distb && a.type === b.type
        ? -1
        : dista > distb && a.type === b.type
          ? 1
          : 0
    } else {
      return a.city < b.city && a.type === b.type
        ? -1
        : a.city > b.city && a.type === b.type
          ? 1
          : 0
    }
  })

  return markers
}

/**
 * Initialize the map and put the default values into search
 */
async function buildLocator () {
  await map.init()
  await map.buildMap()

  map.setAutocomplete(cityInput)

  const position = await map.getCurrentPositionData()
  const isMainCountry = position.address.country === config.map.defaultCountry

  countryInput.val(position.address.country)
  if (isMainCountry) cityInput.show().val(position.address.locality)
  else cityInput.hide().val('')

  let markers = getCountryMarkers(sources.showrooms, position.address.country)
  markers = isMainCountry
    ? getNearMarkers(markers, position.coordinates)
    : markers

  markers = orderMarkers(markers, isMainCountry, position.coordinates)

  map.buildMapMarkers(markers)
  showSearchResults(markers, isMainCountry)

  $('#map_loader').hide()
  $('#filter')
    .removeClass('hidden')
    .addClass('flex')
}

countryInput.on('change', function () {
  const country = $('#country').val()
  // Hide the city input if not needed
  if (country !== config.map.defaultCountry) {
    cityInput.hide().val('')
    searchApplyLocation(country)
  } else {
    cityInput.show().val(config.map.defaultLocality)
    searchApplyLocation(country, config.map.defaultLocality)
  }
})

/**
 * ------------------------------------
 * Start map filters and bottom section
 * ------------------------------------
 */
searchButton.on('click', e => {
  searchApplyLocation($('#country').val(), $('#city').val())
})
locationsListFilters
  .on('click', filterLocationsLink)
  .first()
  .click()
// Mobile show results toggle
$('.toggle_results_btn').on('click', function () {
  $('.tgl_results').toggleClass('hidden')
  $('#filter').toggleClass('top-0')
  $('.toggle_results_btn').toggleClass('hidden')
})
buildCountrySelect('#country', countries)
buildLocator()
